import React from 'react';
import { Label } from '@core-ui/Components/ui/label.tsx';
import { IconBulb } from '@tabler/icons-react';
import { Trans } from 'react-i18next';

interface Props {
    message: string;
}

export const Tip: React.FC<Props> = ({
  message
}) => {
  return (
    <Label
      className="flex gap-2 bg-amber-500/10 text-amber-700 dark:text-amber-300 border border-amber-500/30 px-2 py-1 rounded-md"
    >
      <p className="flex items-center text-xs text-muted-foreground gap-2">
        <IconBulb stroke={1} className="text-amber-700 dark:text-amber-300 shrink-0" />
        <span className="text-amber-700 dark:text-amber-300">
          <Trans
            i18nKey={message}
            components={{ strong: <strong /> }}
          />
        </span>
      </p>
    </Label>
  );
};

export default Tip;